import Button from 'jbc-front/components/Button';
import { useEmployeeQuery } from '@jbc-year-end-adj/2024/hooks/graphql/useQuery';
import { useEmployeeMutation } from '@jbc-year-end-adj/2024/hooks/graphql/useMutation';
import { ButtonContainer as Buttons } from '@jbc-year-end-adj/2024/features/questions/components/ButtonContainer/ButtonContainer';
import useReactRouter from 'use-react-router';
import { Question } from '@jbc-year-end-adj/2024/features/questions/types';
import { SpouseLivingStatus as SpouseLivingStatusTemplate } from '@jbc-year-end-adj/2024/features/questions/templates/SpouseLivingStatus';
import { LoadingPage } from '../../Loading/LoadingPage';
import { SPOUSE_LIVING_STATUS, QueryResult } from './query';
import { ANSWER_SPOUSE_LIVING_STATUS } from './mutation';

interface SpouseLivingStatusProps {
  question: Question;
}

export const SpouseLivingStatus = ({ question }: SpouseLivingStatusProps) => {
  const { loading, data } = useEmployeeQuery<QueryResult>(SPOUSE_LIVING_STATUS);
  const [answer, { loading: loadingAnswer }] = useEmployeeMutation(ANSWER_SPOUSE_LIVING_STATUS);
  const { history } = useReactRouter();

  const handleAnswer = async (isSameHousehold: boolean) => {
    await answer({ variables: { answer: isSameHousehold } });
    history.push('/employee_input');
  };

  if (loading) return <LoadingPage />;

  const isSameHousehold = data?.request?.profile?.spouseLivingStatus?.isSameHousehold;

  return (
    <SpouseLivingStatusTemplate question={question}>
      <Buttons>
        <Button huge primary={isSameHousehold} secondary={!isSameHousehold} disabled={loadingAnswer} onClick={() => handleAnswer(true)}>
          はい
        </Button>
        <Button huge primary={!isSameHousehold} secondary={isSameHousehold} disabled={loadingAnswer} onClick={() => handleAnswer(false)}>
          いいえ
        </Button>
      </Buttons>
    </SpouseLivingStatusTemplate>
  );
};
